import React from 'react';
import Helpers from '../../services/helpers.jsx'

function DeviceView(props) {
	function deviceStatus(lastPing) {
		if(!lastPing)
			return <div className="red">offline</div>

		return (+ new Date(lastPing) > + new Date() - 60 * 60 * 1000) ? <div className="green">online</div> : <div className="red">offline</div>
	}

	function deviceStorage(field) {
		if(!field)
			return '-'

		return (field.externalAvailable / field.externalTotal) < 0.3 ?
			<div className="red">{Helpers.formatBytes(field.externalTotal - field.externalAvailable) + '/' + Helpers.formatBytes(field.externalTotal)}</div>
			:
			<div className="green">{Helpers.formatBytes(field.externalTotal - field.externalAvailable) + '/' + Helpers.formatBytes(field.externalTotal)}</div>
	}

	function deviceType(field) {
		if(!field)
			return '-'

		return Helpers.DEVICES_TYPE_MAP[field]
	}

	function downloadStatus(field) {
		if(!field)
			return '-'
		else if (field.downloaded === field.total) {
			if (field.totalWithUnused)
				return <div className="green">Downloaded ({field.downloaded}/{field.total}/{field.totalWithUnused})</div>
			else
				return <div className="green">Downloaded ({field.downloaded}/{field.total})</div>
		}
		else {
			if(field.totalWithUnused)
				return <div className="orange">{Math.round(field.downloaded/field.total*100)}% ({field.downloaded}/{field.total}/{field.totalWithUnused} tracks)</div>
			else
				return <div className="orange">{Math.round(field.downloaded/field.total*100)}% ({field.downloaded}/{field.total} tracks)</div>
		}
	}

	return <>
		<div className="block">
			<div className='device-info flex-justify-center'>
				<div className="cell">
					<i className="icon-person"></i>
					<span>Client</span>
					<div>{ props.client.name || '-' }</div>
				</div>
			</div>
			<div className='divider' />
			<div className="device-info">
				<div className="cell">
					<i className="icon-bookmark"></i>
					<span>SKU</span>
					<div>{ props.device.sku || '-' }</div>
				</div>

				<div className="cell">
					<i className="icon-numbers"></i>
					<span>Device number</span>
					<div>{ (props.device.deviceType && props.device.deviceType.device) || '-' }</div>
				</div>

				<div className="cell">
					<i className="icon-earthquake"></i>
					<span>Status</span>
					{ deviceStatus(props.device.lastPing) }
				</div>

				<div className="cell">
					<i className="icon-connectivity"></i>
					<span>Connectivity</span>
					{ props.device.connectivity || '-' }
				</div>

				<div className="cell">
					<i className="icon-timezone"></i>
					<span>Timezone</span>
					{ props.device.timezone || '-' }
				</div>

				<div className="cell">
					<i className="icon-deployed-code"></i>
					<span>Software version</span>
					{ props.device.softwareVersion || '-' }
				</div>

				<div className="cell">
					<i className="icon-database"></i>
					<span>Storage used</span>
					{ deviceStorage(props.device.storage) }
				</div>

				<div className="cell">
					<i className="icon-cloud-download"></i>
					<span>Download status</span>
					{ downloadStatus(props.device.downloadStatus) || '-' }
				</div>

				<div className="cell">
					<i className="icon-keyboard-full"></i>
					<span>Device Type</span>
					{ deviceType(props.device.type) || '-' }
				</div>

				<div className="cell">
					<i className="icon-calendar-apps-script"></i>
					<span>Last connection</span>
					{ Helpers.formatDate(props.device.lastPing, "MM/DD/YYYY") || '-' }
				</div>
			</div>
		</div>

	</>
}

export default DeviceView;
